import DotsReorderIcon from "@redotech/redo-icons/dots-reorder.svg";
import TriangleRightIcon from "@redotech/redo-icons/play_right_filled.svg";
import TriangleDownIcon from "@redotech/redo-icons/triangle-down_filled.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import classnames from "classnames";
import { Component, ReactNode } from "react";
import * as styles from "./draggable-fulfillment-card.module.css";

export interface FulfillmentCardData {
  id: string;
  title: string;
  content: ReactNode;
  isExpanded: boolean;
  headerActions?: ReactNode;
}

interface DraggableFulfillmentCardProps {
  item: FulfillmentCardData;
  commonProps: { onToggleExpanded: (id: string) => void };
  dragHandleProps: any;
  isDragging?: boolean;
}

export class DraggableFulfillmentCard extends Component<DraggableFulfillmentCardProps> {
  handleToggle = () => {
    const { item, commonProps } = this.props;
    commonProps.onToggleExpanded(item.id);
  };

  override render() {
    const { item, dragHandleProps, isDragging } = this.props;
    const { isExpanded } = item;

    return (
      <Flex
        bgColor="primary"
        borderBottomWidth="1px"
        borderColor="secondary"
        borderLeftWidth="1px"
        borderRightWidth="1px"
        borderStyle="solid"
        borderTopWidth="none"
        className={classnames(
          styles.cardContainer,
          isDragging && styles.dragging,
          !isExpanded && styles.collapsedState,
        )}
        dir="column"
        gap={isExpanded ? "lg" : "none"}
        pb="xl"
        pt="xl"
        px="3xl"
      >
        <Flex
          align="center"
          className={styles.cardHeader}
          justify="space-between"
          onClick={this.handleToggle}
        >
          <Flex align="center" className={styles.titleArea}>
            <div
              {...dragHandleProps}
              className={styles.dragHandle}
              onClick={(e) => e.stopPropagation()}
            >
              <DotsReorderIcon className={styles.dragHandleIcon} />
            </div>
            <Text color="secondary" fontSize="sm" fontWeight="semibold">
              {item.title}
            </Text>
          </Flex>
          <Flex align="center" gap="md">
            {item.headerActions && (
              <div onClick={(e) => e.stopPropagation()}>
                {item.headerActions}
              </div>
            )}
            <RedoButton
              IconLeading={isExpanded ? TriangleDownIcon : TriangleRightIcon}
            />
          </Flex>
        </Flex>

        {isExpanded && item.content}
      </Flex>
    );
  }
}
